import LaporanSPK from "./LaporanSPK";

export default LaporanSPK